// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"87f8151a","342":"381b2570","794":"f7b330bf"}[chunkId] + ".chunk.js";
};